var React = require('react');

function Paper (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"paper"),React.createElement("path",{"className":"outer","d":"M48,5.82,60.19,18H48ZM4,4H44V20a2,2,0,0,0,2,2H62V84H4ZM1.81,0A2,2,0,0,0,0,2V86a2,2,0,0,0,2,2H64a2,2,0,0,0,2-2V19a2,2,0,0,0-.59-1.43l-17-17A2,2,0,0,0,47,0H1.81Z","key":1}),React.createElement("path",{"className":"inner","d":"M11.81,72a2,2,0,0,0-1.9,2.1,1.92,1.92,0,0,0,.65,1.38A2,2,0,0,0,12,76H34a2,2,0,1,0,0-4H11.81Zm0-11a2,2,0,0,0-1.9,2.1,1.92,1.92,0,0,0,.65,1.38A2,2,0,0,0,12,65H54a2,2,0,1,0,0-4H11.81Zm0-11a2,2,0,0,0-1.9,2.1,1.92,1.92,0,0,0,.65,1.38A2,2,0,0,0,12,54H54a2,2,0,1,0,0-4H11.81Zm0-11a2,2,0,0,0-1.9,2.1,1.92,1.92,0,0,0,.65,1.38A2,2,0,0,0,12,43H54a2,2,0,1,0,0-4H11.81Zm0-11a2,2,0,0,0-1.9,2.1,1.92,1.92,0,0,0,.65,1.38A2,2,0,0,0,12,32H34a2,2,0,1,0,0-4H11.81Z","key":2})]);
}

Paper.defaultProps = {"viewBox":"0 0 66 88"};

module.exports = Paper;

Paper.default = Paper;
